const common = {
  // Nav
  "nav.guides": "หน้าแรก",
  "nav.clientSdk": "ฟีเจอร์",
  "nav.serverApi": "เอกสาร",
  "nav.download": "ดาวน์โหลด",
  "nav.android": "Android",
  "nav.ios": "iOS",
  "nav.pc": "เวอร์ชันเว็บ",
  "nav.github": "GitHub",
  "nav.blog": "บล็อก",

  // Hero
  "hero.badge": "แอปส่งข้อความโอเพนซอร์ส",
  "hero.title1": "Build with",
  "hero.title2": "TupIM",
  "hero.desc": "TupIM คือคอมโพเนนต์การส่งข้อความทันทีแบบโอเพนซอร์สที่พัฒนาโดยผู้เชี่ยวชาญด้าน IM — รวมถึงเซิร์ฟเวอร์ IM และ SDK ไคลเอนต์ เบา ยืดหยุ่น และขยายได้ง่าย ปรับใช้แบบส่วนตัวเพื่อรักษาความปลอดภัยของข้อมูล",
  "hero.download": "ดาวน์โหลด",
  "hero.stat.devs": "นักพัฒนา",
  "hero.stat.msgs": "ข้อความ/วัน",
  "hero.badge2.title": "การเข้ารหัสแบบ E2E",
  "hero.badge2.desc": "ข้อความของคุณปลอดภัยเสมอ",

  // Features
  "features.label": "ฟีเจอร์หลัก",
  "features.title": "ทุกสิ่งที่คุณต้องการสำหรับการสื่อสาร",
  "features.subtitle": "TupIM มอบโซลูชันการส่งข้อความทันทีที่ครบครัน — ข้อความ, การโทร, กลุ่ม, ไฟล์ และอื่นๆ",

  "feat.msg.title": "ข้อความทันที",
  "feat.msg.desc": "ข้อความ, อีโมจิ, รูปภาพ, เสียง และวิดีโอ ส่งภายในมิลลิวินาที",
  "feat.call.title": "การโทรเสียงและวิดีโอ",
  "feat.call.desc": "การโทรแบบหนึ่งต่อหนึ่งหรือกลุ่ม คมชัด พร้อมรองรับการแชร์หน้าจอ",
  "feat.group.title": "กลุ่มแชท",
  "feat.group.desc": "สร้างและจัดการกลุ่มรองรับสมาชิกหลายพันคน พร้อมการควบคุมผู้ดูแลครบครัน",
  "feat.file.title": "การส่งไฟล์",
  "feat.file.desc": "ส่งไฟล์, ภาพ และวิดีโออย่างรวดเร็วและปลอดภัย รองรับการดาวน์โหลดต่อ",
  "feat.encrypt.title": "การเข้ารหัสแบบ E2E",
  "feat.encrypt.desc": "ข้อความทุกข้อความเข้ารหัสแบบ E2E กุญแจส่วนตัวเก็บไว้บนอุปกรณ์ของคุณเท่านั้น",
  "feat.notify.title": "การแจ้งเตือน",
  "feat.notify.desc": "การแจ้งเตือนทันทีบนทุกแพลตฟอร์ม ไม่พลาดข้อความสำคัญ",
  "feat.cross.title": "รองรับ PC+APP",
  "feat.cross.desc": "SDK เดียวครอบคลุม Web, Android และ iOS",
  "feat.private.title": "การปรับใช้แบบส่วนตัว",
  "feat.private.desc": "ปรับใช้บนเซิร์ฟเวอร์ของคุณ คุณเป็นเจ้าของข้อมูล ความปลอดภัยระดับองค์กร",
  "feat.selfhost.title": "ประสิทธิภาพสูง",
  "feat.selfhost.desc": "สร้างด้วย Go โหนดเดียวรองรับการเชื่อมต่อพร้อมกันหลายล้านครั้ง",

  "features.sdk.title": "รองรับ SDK หลายแพลตฟอร์ม",
  "features.sdk.desc": "ไม่ว่าจะใช้เทคโนโลยีใด TupIM มี SDK พร้อมให้คุณ",

  // Api hero section
  "api.hero.title1": "Build with",
  "api.hero.title2": "TupIM",
  "api.hero.desc": "TupIM คือคอมโพเนนต์การส่งข้อความทันทีแบบโอเพนซอร์ส รองรับการปรับใช้แบบส่วนตัว รับรองความปลอดภัยของข้อมูล",
  "api.hero.btn.start": "เริ่มสร้าง",
  "api.hero.btn.guide": "คู่มือเริ่มต้น",

  // Api / Deploy section
  "api.open.title": "โอเพนซอร์สทั้งหมด",
  "api.open.desc": "เซิร์ฟเวอร์ TupIM และ SDK ทั้งหมดเปิดซอร์สบน GitHub ภายใต้ใบอนุญาต MIT",
  "api.open.contrib": "ผู้มีส่วนร่วม",
  "api.open.btn": "ดูบน GitHub",
  "api.deploy.title": "โฮสต์ด้วยตัวเองได้ง่าย",
  "api.deploy.desc": "ปรับใช้ TupIM บนเซิร์ฟเวอร์ของคุณภายในไม่กี่นาที ไม่มีการพึ่งพาบุคคลที่สาม",
  "api.deploy.f1": "ปรับใช้ด้วยคลิกเดียวด้วย Docker Compose",
  "api.deploy.f2": "รองรับการปรับใช้คลัสเตอร์ Kubernetes",
  "api.deploy.f3": "ระบบการตรวจสอบและบันทึกครบครัน",
  "api.deploy.btn": "อ่านเอกสารการปรับใช้",

  // Help
  "help.title": "เราจะช่วยอะไรคุณได้บ้าง?",
  "help.demo.title": "ดูเดโม",
  "help.demo.desc": "คุณสามารถดาวน์โหลดแอปเพื่อทดสอบหรือเยี่ยมชมเว็บไซต์เดโม",
  "help.demo.link": "ไปเลย →",
  "help.support.title": "การสนับสนุน",
  "help.support.desc": "คุณสามารถค้นหาหรือส่งปัญหาที่เกี่ยวข้องในคลังโค้ดของ TupIM",
  "help.support.link": "ไปเลย →",
  "help.faq.title": "คำถามที่พบบ่อย",
  "help.faq.desc": "เรียกดูส่วน FAQ เพื่อค้นหาคำตอบสำหรับคำถามทั่วไป",
  "help.faq.link": "ดู FAQ →",

  // Community
  "community.title": "เข้าร่วมชุมชน",
  "community.desc": "มีส่วนร่วมกับชุมชนที่กำลังเติบโตเพื่อรับข่าวสารล่าสุดและการสนับสนุนผลิตภัณฑ์",
  "community.slack": "Slack →",

  // Download page
  "download.android.badge": "แอป Android",
  "download.android.title": "ดาวน์โหลด TupIM สำหรับ Android",
  "download.android.desc": "แอป Android ที่มีฟีเจอร์ครบครัน รองรับข้อความ, เสียง, วิดีโอคอล, กลุ่มแชท, การส่งไฟล์ และอื่นๆ",
  "download.android.version": "เวอร์ชันล่าสุด",
  "download.android.size": "ขนาดแพ็กเกจ",
  "download.android.require": "ความต้องการระบบ",
  "download.android.require.val": "Android 5.0 ขึ้นไป",
  "download.android.btn": "ดาวน์โหลด APK",
  "download.android.qr": "สแกน QR เพื่อดาวน์โหลด",
  "download.android.qr.desc": "ใช้กล้องโทรศัพท์หรือเครื่องสแกน QR เพื่อสแกน",
  "download.android.tip": "หลังจากดาวน์โหลด โปรดอนุญาตการติดตั้งจากแหล่งที่ไม่รู้จัก",
  "download.android.cta.title": "เริ่มต้นเลย",
  "download.android.cta.desc": "ดาวน์โหลดฟรี — สัมผัสการส่งข้อความทันทีที่ปลอดภัยและมีประสิทธิภาพสูง",

  "download.ios.badge": "แอป iOS",
  "download.ios.title": "ดาวน์โหลด TupIM สำหรับ iOS",
  "download.ios.desc": "แอปส่งข้อความสำหรับ iPhone และ iPad มอบประสบการณ์ native ที่ลื่นไหล",
  "download.ios.version": "เวอร์ชันล่าสุด",
  "download.ios.size": "ขนาดแพ็กเกจ",
  "download.ios.require": "ความต้องการระบบ",
  "download.ios.require.val": "iOS 13.0 ขึ้นไป",
  "download.ios.btn": "ดาวน์โหลดบน App Store",
  "download.ios.btn2": "TestFlight Beta",
  "download.ios.qr": "สแกน QR เพื่อดาวน์โหลด",
  "download.ios.qr.desc": "ใช้กล้อง iPhone สแกนเพื่อไป App Store",
  "download.ios.tip": "รองรับ iPhone และ iPad ที่ใช้ iOS 15.0 ขึ้นไป",
  "download.ios.cta.title": "เริ่มต้นเลย",
  "download.ios.cta.desc": "ดาวน์โหลดฟรีบน App Store หรือเข้าร่วม TestFlight เพื่อสัมผัสฟีเจอร์ล่าสุด",

  // PC / Web version
  "download.pc.badge": "เวอร์ชันเบราว์เซอร์",
  "download.pc.title": "TupIM เวอร์ชันเว็บเบราว์เซอร์",
  "download.pc.desc": "ไม่ต้องติดตั้ง เข้าถึงจากเว็บเบราว์เซอร์ได้ทุกที่ทุกเวลา และเพลิดเพลินกับฟีเจอร์การส่งข้อความทันทีครบครัน",
  "download.pc.btn.open": "เปิดเลย",
  "download.pc.tip": "ฟรี · ไม่ต้องติดตั้ง ซิงค์กับทุกอุปกรณ์",
  "download.pc.features.title": "ฟีเจอร์หลัก",
  "download.pc.features.subtitle": "ประสบการณ์การสื่อสารเต็มรูปแบบผ่านเบราว์เซอร์",
  "download.pc.screenshots.title": "ภาพหน้าจอ",
  "download.pc.ss.chats": "แชท",
  "download.pc.ss.call": "วิดีโอคอล",
  "download.pc.ss.group": "กลุ่มแชท",
  "download.pc.ss.file": "จัดการไฟล์",
  "download.pc.cta.title": "เริ่มต้นบนเว็บเบราว์เซอร์",
  "download.pc.cta.desc": "ไม่ต้องติดตั้ง ใช้งานได้ทันทีบนเบราว์เซอร์ใดก็ได้",
  "download.pc.cta.btn": "เปิดบนเบราว์เซอร์",
  "download.pc.browser.support": "เบราว์เซอร์ที่รองรับ",

  // Download features
  "download.feature.msg": "ข้อความทันที",
  "download.feature.msg.desc": "รองรับข้อความ, อีโมจิ, รูปภาพ, เสียง, วิดีโอ และประเภทข้อความอื่นๆ",
  "download.feature.call": "การโทรเสียง/วิดีโอ",
  "download.feature.call.desc": "การโทรเสียง/วิดีโอแบบหนึ่งต่อหนึ่งหรือกลุ่ม ชัดเจนและลื่นไหล",
  "download.feature.group": "กลุ่มแชท",
  "download.feature.group.desc": "สร้างและจัดการกลุ่ม รองรับสมาชิกหลายพันคน",
  "download.feature.file": "การส่งไฟล์",
  "download.feature.file.desc": "ส่งไฟล์, ภาพ และวิดีโออย่างรวดเร็วและปลอดภัย",
  "download.feature.encrypt": "การเข้ารหัสแบบ E2E",
  "download.feature.encrypt.desc": "ข้อความทุกข้อความเข้ารหัสแบบ E2E เพื่อความเป็นส่วนตัว",
  "download.feature.notify": "การแจ้งเตือน",
  "download.feature.notify.desc": "การแจ้งเตือนทันทีสำหรับข้อความสำคัญ ไม่พลาดสักข้อความ",
  "download.feature.shortcut": "ปุ่มลัด",
  "download.feature.shortcut.desc": "เพิ่มประสิทธิภาพด้วยปุ่มลัดและการดำเนินการรวดเร็วบนเดสก์ท็อป",

  // Download Section (homepage)
  "dl.label": "ดาวน์โหลด",
  "dl.title": "ดาวน์โหลดหลายแพลตฟอร์ม",
  "dl.subtitle": "ใช้งานได้บน Android, iOS และเบราว์เซอร์หลักทั้งหมด ข้อความซิงค์ได้อย่างราบรื่นบนทุกอุปกรณ์",
  "dl.sync": "ทุกเวอร์ชันฟรี ข้อมูลซิงค์แบบเรียลไทม์บนทุกอุปกรณ์",
  "dl.android.title": "Android",
  "dl.android.desc": "แอปส่งข้อความที่มีฟีเจอร์ครบครันสำหรับโทรศัพท์และแท็บเล็ต Android",
  "dl.android.req": "Android 5.0+",
  "dl.android.btn": "ดาวน์โหลดสำหรับ Android",
  "dl.ios.title": "iPhone & iPad",
  "dl.ios.desc": "ประสบการณ์ iOS native สำหรับ iPhone และ iPad ลื่นไหล รวดเร็ว ออกแบบมาสำหรับอุปกรณ์ Apple",
  "dl.ios.req": "iOS 15.0+",
  "dl.ios.btn": "ดาวน์โหลดสำหรับ iOS",
  "dl.pc.title": "เวอร์ชันเบราว์เซอร์",
  "dl.pc.desc": "ไม่ต้องติดตั้ง เข้าถึงได้ทันทีจากเว็บเบราว์เซอร์",
  "dl.pc.req": "เบราว์เซอร์ใดก็ได้",
  "dl.pc.btn": "เปิดบนเบราว์เซอร์",

  // Showcase
  "showcase.label": "เจาะลึก",
  "showcase.title": "ทุกฟีเจอร์ ออกแบบมาเพื่อคุณ",
  "showcase.subtitle": "จากข้อความทันทีถึงวิดีโอคอล ทุกโมดูลได้รับการขัดเกลาอย่างละเอียดเพื่อมอบประสบการณ์การสื่อสารที่ลื่นไหลที่สุด",
  "showcase.msg.title": "ข้อความทันที",
  "showcase.msg.tag": "ข้อความ",
  "showcase.msg.desc": "ส่งภายในมิลลิวินาที รองรับข้อความมัลติมีเดียทุกประเภท",
  "showcase.msg.p1": "รองรับ 20+ ประเภทข้อความ: ข้อความ, อีโมจิ, รูปภาพ, เสียง, วิดีโอ, ไฟล์ และอื่นๆ",
  "showcase.msg.p2": "ยืนยันการอ่านแสดงให้ทั้งสองฝ่าย",
  "showcase.msg.p3": "รองรับการเรียกคืนข้อความ, ตอบกลับแบบอ้างอิง และ @กล่าวถึง",
  "showcase.msg.p4": "ข้อความออฟไลน์ซิงค์อัตโนมัติ ไม่พลาดการสนทนา",
  "showcase.call.title": "การโทรเสียงและวิดีโอ",
  "showcase.call.tag": "การโทร",
  "showcase.call.desc": "การโทร HD ที่เสถียรแม้ในเครือข่ายอ่อน",
  "showcase.call.p1": "รองรับการโทรเสียง/วิดีโอแบบหนึ่งต่อหนึ่งและหลายคน",
  "showcase.call.p2": "ฟีเจอร์แชร์หน้าจอในตัว",
  "showcase.call.p3": "บิตเรตปรับตัวรักษาการโทรให้เสถียรในทุกสภาพเครือข่าย",
  "showcase.call.p4": "ฟีเจอร์บันทึกการโทรเพื่อเล่นซ้ำเมื่อต้องการ",
  "showcase.group.title": "กลุ่มแชท",
  "showcase.group.tag": "กลุ่ม",
  "showcase.group.desc": "การจัดการกลุ่มที่ยืดหยุ่นและทรงพลัง รองรับสมาชิกหลายพันคน",
  "showcase.group.p1": "กลุ่มเดียวรองรับสมาชิกสูงสุด 1,000 คน",
  "showcase.group.p2": "บทบาทผู้ดูแลหลายระดับพร้อมการควบคุมสิทธิ์ละเอียด",
  "showcase.group.p3": "ประกาศกลุ่ม, ไฟล์ที่ใช้ร่วมกัน และอัลบั้มกลุ่มในตัว",
  "showcase.group.p4": "ปิดเสียง, เตะออก และอนุมัติการเข้าร่วมสำหรับการดูแลกลุ่มครบครัน",
  "showcase.security.title": "การเข้ารหัสแบบ E2E",
  "showcase.security.tag": "ความเป็นส่วนตัว",
  "showcase.security.desc": "การเข้ารหัส E2E — กุญแจส่วนตัวไม่เคยออกจากอุปกรณ์ของคุณ",
  "showcase.security.p1": "ข้อความทั้งหมดเข้ารหัส E2E อย่างสมบูรณ์ — เซิร์ฟเวอร์ไม่สามารถอ่านได้",
  "showcase.security.p2": "รองรับการลบอัตโนมัติหลังอ่าน",
  "showcase.security.p3": "โฮสต์ด้วยตัวเอง — ข้อมูลของคุณอยู่บนเซิร์ฟเวอร์ของคุณ",
  "showcase.security.p4": "การตรวจสอบความปลอดภัยจากบุคคลที่สามเป็นประจำ",

  // Pricing
  "pricing.label": "แผนราคา",
  "pricing.title": "เลือกแผนที่เหมาะกับคุณ",
  "pricing.subtitle": "ไม่ว่าจะเป็นนักพัฒนาอิสระ ทีมกำลังเติบโต หรือองค์กรขนาดใหญ่ — TupIM มีแผนที่เหมาะสำหรับทุกขนาด",
  "pricing.popular": "ยอดนิยมที่สุด",
  "pricing.includes": "สิ่งที่รวมอยู่",
  "pricing.note": "ทุกแผนรวมการทดลองใช้ฟรี 7 วัน ไม่ต้องใช้บัตรเครดิต",
  "pricing.starter.name": "สตาร์เตอร์",
  "pricing.starter.tag": "ส่วนตัว / ทีมเล็ก",
  "pricing.starter.desc": "เหมาะสำหรับนักพัฒนาอิสระและแอปขนาดเล็กที่ต้องการสำรวจความสามารถหลักของ TupIM",
  "pricing.starter.cta": "เริ่มต้นฟรี",
  "pricing.starter.f1": "ผู้ใช้งาน active สูงสุด 500 คน",
  "pricing.starter.f2": "ข้อความ, รูปภาพ และเสียง",
  "pricing.starter.f3": "การโทรเสียงและวิดีโอแบบหนึ่งต่อหนึ่ง",
  "pricing.starter.f4": "กลุ่มพื้นฐาน (สูงสุด 50 คน)",
  "pricing.starter.f5": "การสนับสนุนทางเทคนิคจากชุมชน",
  "pricing.starter.m1": "การโทรกลุ่มหลายคน",
  "pricing.starter.m2": "การปรับใช้แบบส่วนตัว",
  "pricing.starter.m3": "การสนับสนุนทางเทคนิคเฉพาะ",
  "pricing.pro.name": "โปร",
  "pricing.pro.tag": "ทีมกำลังเติบโต",
  "pricing.pro.desc": "สร้างมาสำหรับผลิตภัณฑ์และทีมที่เติบโตเร็ว ปลดล็อกชุดฟีเจอร์เต็มรูปแบบ",
  "pricing.pro.cta": "ติดต่อฝ่ายขาย",
  "pricing.pro.f1": "ผู้ใช้งาน active สูงสุด 10,000 คน",
  "pricing.pro.f2": "ข้อความมัลติมีเดียทุกประเภท",
  "pricing.pro.f3": "การโทรกลุ่มเสียงและวิดีโอหลายคน",
  "pricing.pro.f4": "กลุ่มสูงสุด 1,000 คน",
  "pricing.pro.f5": "แชร์หน้าจอและบันทึกการโทร",
  "pricing.pro.f6": "การเข้ารหัส E2E และลบอัตโนมัติหลังอ่าน",
  "pricing.pro.m1": "การปรับใช้แบบส่วนตัว",
  "pricing.enterprise.name": "เอนเตอร์ไพรส์",
  "pricing.enterprise.tag": "องค์กรขนาดใหญ่",
  "pricing.enterprise.desc": "ออกแบบสำหรับแอปพลิเคชันขนาดใหญ่และความต้องการระดับองค์กร โฮสต์ด้วยตัวเองอย่างสมบูรณ์",
  "pricing.enterprise.cta": "รับใบเสนอราคา",
  "pricing.enterprise.f1": "ผู้ใช้งาน active ไม่จำกัด",
  "pricing.enterprise.f2": "ทุกฟีเจอร์ ไม่มีข้อจำกัด",
  "pricing.enterprise.f3": "การปรับใช้แบบส่วนตัวและใบอนุญาตซอร์สโค้ด",
  "pricing.enterprise.f4": "ความพร้อมใช้งานสูงของคลัสเตอร์ Kubernetes",
  "pricing.enterprise.f5": "รับประกัน SLA 99.99% uptime",
  "pricing.enterprise.f6": "ที่ปรึกษาทางเทคนิคเฉพาะ",
  "pricing.enterprise.f7": "การพัฒนาฟีเจอร์ตามสั่ง",

  // Docs page
  "docs.title": "เอกสาร",
  "docs.group.start": "เริ่มต้น",
  "docs.group.core": "ฟีเจอร์หลัก",
  "docs.group.dev": "คู่มือนักพัฒนา",
  "docs.nav.introduction": "แนะนำ",
  "docs.nav.quickstart": "เริ่มต้นอย่างรวดเร็ว",
  "docs.nav.messaging": "ข้อความทันที",
  "docs.nav.calls": "การโทรเสียงและวิดีโอ",
  "docs.nav.groups": "การจัดการกลุ่ม",
  "docs.nav.encryption": "ความปลอดภัยและการเข้ารหัส",
  "docs.nav.sdk": "การรวม SDK",
  "docs.nav.deployment": "โฮสต์ด้วยตัวเอง",
  "docs.nav.api": "เอกสารอ้างอิง API",
  "docs.toc": "สารบัญ",
  "docs.copied": "คัดลอกแล้ว",
  "docs.copy": "คัดลอก",
  "docs.install": "ติดตั้ง",
  "docs.init": "เริ่มต้น",

  // Docs - Server group
  "docs.group.server": "เซิร์ฟเวอร์",
  "docs.nav.sfu": "การคำนวณแบนด์วิดธ์ SFU",
  "docs.sfu.title": "วิธีคำนวณแบนด์วิดธ์สำหรับการประชุมวิดีโอ SFU",
  "docs.sfu.intro": "ในสถาปัตยกรรม SFU ผู้เข้าร่วมแต่ละคนอัปโหลดสตรีมของตนเองไปยังเซิร์ฟเวอร์ SFU และเซิร์ฟเวอร์จะส่งต่อสตรีมจากผู้อื่นๆ เอกสารนี้อธิบายวิธีประเมินความต้องการแบนด์วิดธ์",
  "docs.sfu.arch.title": "ภาพรวมสถาปัตยกรรม SFU",
  "docs.sfu.arch.desc": "ต่างจาก MCU, SFU ไม่ผสมสตรีม ผู้เข้าร่วมแต่ละคนมี N-1 ดาวน์ลิงก์และ 1 อัปลิงก์ ทำให้ SFU ขยายได้ดีสำหรับการโทรกลุ่มใหญ่",
  "docs.sfu.formula.title": "สูตรคำนวณแบนด์วิดธ์",
  "docs.sfu.formula.uplink": "อัปลิงก์ (ต่อผู้ใช้): อัปโหลด 1 วิดีโอสตรีม",
  "docs.sfu.formula.downlink": "ดาวน์ลิงก์ (ต่อผู้ใช้): ดาวน์โหลด (N-1) วิดีโอสตรีม",
  "docs.sfu.formula.total": "แบนด์วิดธ์เซิร์ฟเวอร์รวม = N × bitrate อัป + N × (N-1) × bitrate ดาวน์",
  "docs.sfu.params.title": "ค่า bitrate อ้างอิง",
  "docs.sfu.params.hd": "HD (720p): อัป ~1.5 Mbps / ดาวน์ ~1.2 Mbps",
  "docs.sfu.params.sd": "SD (480p): อัป ~0.8 Mbps / ดาวน์ ~0.6 Mbps",
  "docs.sfu.params.ld": "ต่ำ (240p): อัป ~0.3 Mbps / ดาวน์ ~0.25 Mbps",
  "docs.sfu.example.title": "ตัวอย่างการคำนวณ",
  "docs.sfu.example.desc": "ตัวอย่างต่อไปนี้สมมติคุณภาพ HD (720p) อัปลิงก์ 1.5 Mbps และดาวน์ลิงก์ 1.2 Mbps ต่อผู้เข้าร่วม",
  "docs.sfu.note.title": "ข้อควรระวังสำคัญ",
  "docs.sfu.note.1": "เพิ่ม overhead ~20% สำหรับ header, การส่งซ้ำ และทราฟฟิก RTCP",
  "docs.sfu.note.2": "เปิดใช้ simulcast เพื่อให้ SFU เลือกคุณภาพสตรีมตามผู้รับแต่ละคน",
  "docs.sfu.note.3": "สตรีมเสียงมักเพิ่ม 50–100 kbps ต่อผู้เข้าร่วม",
  "docs.sfu.note.4": "สตรีมแชร์หน้าจออาจต้องการแบนด์วิดธ์อัปลิงก์เพิ่มเติม 2–4 Mbps",

  // Footer
  "footer.tagline": "TupIM\u00a0ปกป้องความเป็นส่วนตัวอย่างครบครัน ด้วยแชทส่วนตัว, กลุ่มแชท, ข้อความปลอดภัย & อื่นๆ",
  "footer.col.product": "ผลิตภัณฑ์",
  "footer.col.developer": "นักพัฒนา",
  "footer.col.company": "บริษัท",
  "footer.link.features": "ฟีเจอร์",
  "footer.link.download": "ดาวน์โหลด",
  "footer.link.changelog": "บันทึกการเปลี่ยนแปลง",
  "footer.link.docs": "เอกสาร",
  "footer.link.api": "เอกสารอ้างอิง API",
  "footer.link.github": "GitHub",
  "footer.link.about": "เกี่ยวกับเรา",
  "footer.link.blog": "บล็อก",
  "footer.link.contact": "ติดต่อ",
  "footer.copyright": "© 2024 TupIM. All rights reserved.",
  "footer.lang.zh": "繁體中文",
  "footer.lang.en": "English",

  // About page
  "about.badge": "เกี่ยวกับเรา",
  "about.hero.title": "สร้างโครงสร้างการส่งข้อความโอเพนซอร์ชยุคใหม่",
  "about.hero.desc": "TupIM ก่อตั้งโดยวิศวกรที่มีประสบการณ์ด้าน IM อันลึกซึ้ง มุ่งมั่นให้นักพัฒนาทุกคนสามารถสร้างแอปพลิเคชันส่งข้อความระดับองค์กรด้วยต้นทุนน้อยที่สุด",
  "about.hero.cta1": "ติดต่อเรา",
  "about.hero.cta2": "ดูบน GitHub",
  "about.stat.devs": "นักพัฒนาทั่วโลก",
  "about.stat.msgs": "ข้อความ / วัน",
  "about.stat.stars": "GitHub Stars",
  "about.stat.countries": "ประเทศ",
  "about.mission.label": "ภารกิจ & วิสัยทัศน์",
  "about.mission.title": "ทุกแอปพลิเคชันควรมีฟีเจอร์การส่งข้อความที่แข็งแกร่ง",
  "about.mission.p1": "เทคโนโลยี IM ถูกครองงำโดยผู้เล่นรายใหญ่มานาน. TupIM ถูกสร้างขึ้นมาเพื่อทำลายวงจรนี้",
  "about.mission.p2": "เราเสนอโซลูชัน IM โอเพนซอร์ชที่ครบครัน — server, Web SDK, iOS SDK และ Android SDK.",
  "about.mission.p3": "วิสัยทัศน์ของเรา: เป็นโครงสร้างการส่งข้อความโอเพนซอร์ชที่น่าเชื่อถือที่สุดในโลก.",
  "about.values.label": "ค่านิยมหลัก",
  "about.values.title": "สิ่งที่เราเชื่อ",
  "about.values.subtitle": "ค่านิยมเหล่านี้นำทางทุกการตัดสินใจด้านเทคนิคและทิศทางสินค้า.",
  "about.value.opensource.title": "เปิด & โปร่งใส",
  "about.value.opensource.desc": "โค้ดทั้งหมดเปิดเผยอย่างสมบูรณ์บน GitHub ภายใต้ใบอนุญาต MIT.",
  "about.value.privacy.title": "ความเป็นส่วนตัวเป็นอันดับแรก",
  "about.value.privacy.desc": "การเข้ารหัสแบบ End-to-End คือมาตรฐาน ไม่ใช่ตัวเลือก.",
  "about.value.performance.title": "ประสิทธิภาพสูงสุด",
  "about.value.performance.desc": "เซิร์ฟเวอร์สมรรถภาพสูงสร้างด้วย Go รองรับการเชื่อมต่อพร้อมกันหลายล้านรายการบนโนดเดียว.",
  "about.value.community.title": "ขับเคลื่อนโดยชุมชน",
  "about.value.community.desc": "ทิศทางสินค้าถูกกำหนดโดยชุมชน.",
  "about.value.developer.title": "ประสบการณ์นักพัฒนา",
  "about.value.developer.desc": "เอกสารสมบูรณ์, เดโมครบถ้วน และ API SDK เรียบร้อยเพื่อเริ่มต้นง่าย.",
  "about.value.enterprise.title": "พร้อมสำหรับองค์กร",
  "about.value.enterprise.desc": "Kubernetes cluster, HA หลายภูมิภาค, การติดตามและการแจ้งเตือนครบครัน.",
  "about.timeline.label": "เหตุการณ์สำคัญ",
  "about.timeline.title": "ทุกก้าวที่เราได้เดิน",
  "about.timeline.2020q1.date": "Q1 2020",
  "about.timeline.2020q1.title": "เริ่มต้นโครงการ",
  "about.timeline.2020q1.desc": "ก่อตั้งทีมหลัก เริ่มวิจัยและออกแบบสถาปัตยกรรมเซิร์ฟเวอร์ 0e1cลิตภาพสูงด้วย Go.",
  "about.timeline.2020q3.date": "Q3 2020",
  "about.timeline.2020q3.title": "เปิดตัวโอเพนซอร์ชครั้งแรก",
  "about.timeline.2020q3.desc": "OpenIM Server v1.0 เผยแพร่บน GitHub ได้รับ 500+ ดาวในสัปดาห์แรก.",
  "about.timeline.2021q2.date": "Q2 2021",
  "about.timeline.2021q2.title": "SDK ครอบคลุมทุกแพลตฟอร์ม",
  "about.timeline.2021q2.desc": "iOS, Android และ Web SDK เปิดตัวพร้อมกัน.",
  "about.timeline.2022q1.date": "Q1 2022",
  "about.timeline.2022q1.title": "GitHub 10,000 ดาว",
  "about.timeline.2022q1.desc": "ผ่าน  10K ดาวบน GitHub.",
  "about.timeline.2022q4.date": "Q4 2022",
  "about.timeline.2022q4.title": "เปิดตัว Enterprise Edition",
  "about.timeline.2022q4.desc": "เปิดตัวแผนองค์กรพร้อมการประกัน SLA.",
  "about.timeline.2023q2.date": "Q2 2023",
  "about.timeline.2023q2.title": "โมดูลเสียง & วิดีโอสด",
  "about.timeline.2023q2.desc": "สับสนันการโทรแบบเต็มรูปแบบอิงจาก WebRTC บวกรวมอย่างเป็นทางการ.",
  "about.timeline.2024q1.date": "Q1 2024",
  "about.timeline.2024q1.title": "นักพัฒนาทั่วโลก 50,000 คน",
  "about.timeline.2024q1.desc": "มากกว่า 50K นักพัฒนาใช้งาน TupIM ทั่วโลก.",
  "about.timeline.2024q4.date": "Q4 2024",
  "about.timeline.2024q4.title": "อัปเกรดแบรนด์ TupIM",
  "about.timeline.2024q4.desc": "อัปเกรดแบรนด์ทั้งหมดเป็น TupIM เว็บไซต์และระบบเอกสารใหม่.",
  "about.team.label": "ทีมของเรา",
  "about.team.title": "คนที่อยู่เบื้องหลัง TupIM",
  "about.team.subtitle": "กลุ่มวิศวกรผู้รักโอเพนซอร์ชและหลงใหลกเทคโนโลยี IM.",
  "about.team.ceo.name": "Alex Chen",
  "about.team.ceo.role": "CEO & Co-Founder",
  "about.team.ceo.bio": "อดีตสถาปนิก IM บริษัทเทคโนโลยีชั้นนำ มีประสบการณ์มากกว่า 10 ปี.",
  "about.team.cto.name": "Kevin Wang",
  "about.team.cto.role": "CTO & Co-Founder",
  "about.team.cto.bio": "ผู้มีส่วนร่วมหลักของ Go และสถาปนิกหลักของ OpenIM Server.",
  "about.team.lead.name": "Sophie Lin",
  "about.team.lead.role": "Lead Engineer",
  "about.team.lead.bio": "วิศวกรฟุลสแต็คคุมเรื่อง Web SDK และสถาปัตยกรรม frontend.",
  "about.team.sdk.name": "James Zhang",
  "about.team.sdk.role": "Mobile SDK Lead",
  "about.team.sdk.bio": "ผู้เชี่ยวชาญ iOS & Android นำการออกแบบ mobile SDK.",
  "about.team.infra.name": "David Liu",
  "about.team.infra.role": "Infrastructure Lead",
  "about.team.infra.bio": "ผู้เชี่ยวชาญ Kubernetes ดูแลโซลูชัน cloud-native.",
  "about.team.design.name": "Emma Wu",
  "about.team.design.role": "Product Design Lead",
  "about.team.design.bio": "ผู้เชี่ยวชาญ UX สำหรับเครื่องมือนักพัฒนา.",

  // Contact page
  "contact.badge": "ติดต่อ",
  "contact.hero.title": "มีคำถาม? เราอยู่ที่นี่.",
  "contact.hero.desc": "ไม่ว่าจะเป็นปัญหาด้านเทคนิค, คำถามทางธุรกิจ หรือการขอได้จากสื่อ — เลือกช่องทางที่เหมาะสมที่สุด.",
  "contact.channel.support.title": "ฝ่ายสนับสนุนเทคนิค",
  "contact.channel.support.desc": "พบบัก, ปัญหา SDK หรือคำถามเกี่ยวกับการนำใช้งาน? เปิด issue บน GitHub หรือเข้าร่วม Slack.",
  "contact.channel.support.link1": "ส่ง GitHub Issue",
  "contact.channel.support.link2": "เข้าร่วมชุมชน Slack",
  "contact.channel.business.title": "สอบถามเรื่องธุรกิจ",
  "contact.channel.business.desc": "สนใจแผนองค์กร, ใบอนุญาตเชิงพาณิชย์ หรือความร่วมมือสั่งผลิต?",
  "contact.channel.business.link1": "ส่งอีเมลธุรกิจ",
  "contact.channel.business.link2": "ปรึกษาผ่าน WeChat",
  "contact.channel.media.title": "สื่อมวลชน & PR",
  "contact.channel.media.desc": "สัมภาษณ์สื่อ, รีวิวสินค้า หรือกิจกรรมความร่วมมือ?",
  "contact.channel.media.link1": "อีเมลติดต่อสื่อ",
  "contact.channel.media.link2": "ติดตามบน Twitter",
  "contact.channel.community.title": "ชุมชนโอเพนซอร์ช",
  "contact.channel.community.desc": "เข้าร่วมชุมชนโอเพนซอร์ชของเรา เชื่อมต่อกับนักพัฒนาทั่วโลก.",
  "contact.channel.community.link1": "เข้าร่วม Slack",
  "contact.channel.community.link2": "ติดตามบน GitHub",
  "contact.response.note": "เวลาตอบสนองทั่วไป: ปัญหาเทคนิคภายใน 24 ชั่วโมง · คำถามธุรกิจ 1-2 วันทำการ · คำขอสื่อ 2-3 วันทำการ",
  "contact.faq.label": "คำถามที่พบบ่อย",
  "contact.faq.title": "สิ่งที่คุณอาจอยากรู้",
  "contact.faq.f1.q": "TupIM ฟรีสมบูรณ์หรือเปล่า?",
  "contact.faq.f1.a": "ใช่ — เซิร์ฟเวอร์และ SDK ที่เป็นเอเปนซอร์ชและฟรีภายใต้ใบอนุญาต MIT.",
  "contact.faq.f2.q": "เริ่มต้นใช้งานได้อย่างไร?",
  "contact.faq.f2.a": "ตรวจสอบ Quick Start docs. ติดตั้งเซิร์ฟเวอร์ใน 5 นาทีด้วย Docker Compose.",
  "contact.faq.f3.q": "ความปลอดภัยของข้อมูลถูกรับประกันอย่างไร?",
  "contact.faq.f3.a": "TupIM รองรับการประกาศใช้งานแบบส่วนตัว — ข้อมูลทั้งหมดอยู่บนเซิร์ฟเวอร์ของคุณเอง.",
  "contact.faq.f4.q": "รองรับขนาดการเชื่อมต่อพร้อมกันเท่าไร?",
  "contact.faq.f4.a": "สถาปัตยกรรม Go ของ TupIM Server รองรับการเชื่อมต่อพร้อมกัน 1 ล้าน+ บนโนดเดียว.",
  "contact.faq.f5.q": "จะรับใบอนุญาตองค์กรได้อย่างไร?",
  "contact.faq.f5.a": "ติดต่อทีมขายผ่านอีเมลธุรกิจหรือ WeChat.",

  "nav.about": "เกี่ยวกับเรา",
  "nav.contact": "ติดต่อ",

  // Page title
  "page.title": "TupIM — ปกป้องความเป็นส่วนตัวครบครัน | แชทส่วนตัว | กลุ่มแชท | ข้อความปลอดภัย & อื่นๆ",
};

export default common;